import { matchPath } from 'react-router';

import { RouteEnum } from '@/models/route/Route.model.ts';

export enum CatalogSection {
  DISHES = 'DISHES',
  HUB = 'HUB',
  IMPORT = 'IMPORT',
  OFFER_ELEMENTS = 'OFFER_ELEMENTS',
  SETS = 'SETS',
}

export const CATALOG_SECTION_ROUTES: Record<CatalogSection, RouteEnum> = {
  [CatalogSection.DISHES]: RouteEnum.DISHES,
  [CatalogSection.HUB]: RouteEnum.CATALOG,
  [CatalogSection.IMPORT]: RouteEnum.DISHES_IMPORT,
  [CatalogSection.OFFER_ELEMENTS]: RouteEnum.OFFER_ELEMENTS,
  [CatalogSection.SETS]: RouteEnum.OFFER_GROUP_DEFINITIONS,
};

export const CATALOG_SECTION_ORDER: CatalogSection[] = [
  CatalogSection.HUB,
  CatalogSection.DISHES,
  CatalogSection.SETS,
  CatalogSection.OFFER_ELEMENTS,
  CatalogSection.IMPORT,
];

const SECTION_MATCH_ORDER: CatalogSection[] = [
  CatalogSection.HUB,
  CatalogSection.IMPORT,
  CatalogSection.DISHES,
  CatalogSection.SETS,
  CatalogSection.OFFER_ELEMENTS,
];

export const catalogSectionOf = (pathname: string): CatalogSection | null =>
  SECTION_MATCH_ORDER.find(section =>
    matchPath({ end: false, path: CATALOG_SECTION_ROUTES[section] }, pathname),
  ) ?? null;
